export function isAuth(): boolean | null {
    let tok = null;

    try {
        tok = localStorage.getItem("__timed_user_token__");
    } catch (error) {
        console.warn("[auth] localStorage unavailable", error);
    }

    if(tok){
        return true;
    }
    return false;
}
